<template>
  <div style="position: relative">
    <!-- Contained original format -->
    <div :style="previewOriginalCSS" />
    <!-- Preview of target format -->
    <v-card
      :width="previewTargetWidth"
      :height="previewTargetHeight"
      :min-width="previewTargetWidth"
      :min-height="previewTargetHeight"
      :max-width="previewTargetWidth"
      :max-height="previewTargetHeight"
      flat
      class="pa-0 clickable tvformat-preview-card"
      :class="{selected: selected}"
    >
      <v-layout
        justify-center
        align-center
        fill-height
        class="title"
        :class="{'grey--text text--darken-1': !selected}"
        style="word-break: break-word"
        :style="{color: selected ? 'var(--msr-color-primary)' : 'initial'}"
      >
        {{ name }}
      </v-layout>
    </v-card>
  </div>
</template>

<script>
export default {
  name: 'TvFormatPreviewCard',
  props: {
    name: {
      type: String,
      required: true,
    },
    originalWidth: {
      type: Number,
      required: true,
    },
    originalHeight: {
      type: Number,
      required: true,
    },
    targetWidth: {
      type: Number,
      required: true,
    },
    targetHeight: {
      type: Number,
      required: true,
    },
    selected: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      maxDimension: 110,
    };
  },
  computed: {
    previewTargetWidth() {
      if (this.targetWidth > this.targetHeight) {
        return this.maxDimension;
      }
      return (this.targetWidth / this.targetHeight) * this.maxDimension;
    },
    previewTargetHeight() {
      if (this.targetHeight > this.targetWidth) {
        return this.maxDimension;
      }
      return (this.targetHeight / this.targetWidth) * this.maxDimension;
    },
    previewOriginalDimensions() {
      const originalRatio = this.originalWidth / this.originalHeight;
      let containWidth = this.previewTargetWidth;
      let containHeight = containWidth / originalRatio;
      if (containHeight > this.previewTargetHeight) {
        containHeight = this.previewTargetHeight;
        containWidth = containHeight * originalRatio;
      }
      return {
        width: Number(containWidth),
        height: Number(containHeight),
      };
    },
    previewOriginalCSS() {
      const horizontalSpace = this.previewOriginalDimensions.width;
      const verticalSpace = this.previewOriginalDimensions.height;
      return {
        background: this.selected
          ? 'rgba(255, 102, 94, 0.06)'
          : 'rgba(0, 0, 0, 0.06)',
        border: this.selected
          ? '1px solid rgba(255, 102, 94, 0.12)'
          : '1px solid rgba(0, 0, 0, 0.12)',
        position: 'absolute',
        left: `calc(50% - ${horizontalSpace / 2}px)`,
        top: `calc(50% - ${verticalSpace / 2}px)`,
        'z-index': '1',
        width: `${this.previewOriginalDimensions.width}px`,
        height: `${this.previewOriginalDimensions.height}px`,
      };
    },
  },
};
</script>

<style scoped>
.tvformat-preview-card {
  border: 2px solid rgba(0, 0, 0, 0.48);
  border-radius: 0px;
}

.tvformat-preview-card.selected {
  border-color: var(--msr-color-primary) !important;
}
</style>



// WEBPACK FOOTER //
// src/components/TvFormatPreviewCard.vue